import React, { FC } from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

interface ConfirmDialogProps {
  onConfirm?: () => void;
  title: string;
  content?: string;
  confirmLabel: string;
  cancelLabel: string;
  closeDialog: () => void;
}

export const ConfirmDialog: FC<ConfirmDialogProps> = ({
  onConfirm,
  closeDialog,
  title,
  content,
  confirmLabel,
  cancelLabel,
}) => {
  const confirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    closeDialog();
  };

  return (
    <>
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      {content && (
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
      )}
      <DialogActions>
        <Button onClick={closeDialog} color="primary">
          {cancelLabel}
        </Button>
        <Button onClick={confirm} color="primary" autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </>
  );
};
